var _circle, _path, _path2, _path3, _ellipse, _path4, _path5, _ellipse2, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVeryGoodGray(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "happy",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_581",
    "data-name": "Ellipse 581",
    cx: 10,
    cy: 10,
    r: 10,
    fill: "#d1d1cf"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_10509",
    "data-name": "Path 10509",
    d: "M21.329,11.329A10,10,0,0,1,3.545,17.608,10,10,0,0,0,17.608,3.545,9.989,9.989,0,0,1,21.329,11.329Z",
    transform: "translate(-1.329 -1.329)",
    fill: "#d1d1cf"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10510",
    "data-name": "Path 10510",
    d: "M11.27,9.467C11,14.113,9.805,13.656,7.995,13.656c-1.669,0-2.916-1.876-2.781-4.189s1.6-4.189,3.269-4.189S11.4,7.154,11.27,9.467Z",
    transform: "translate(-1.951 -1.979)",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10511",
    "data-name": "Path 10511",
    d: "M11.4,13.467a1.306,1.306,0,1,1-1.329-1.329A1.33,1.33,0,0,1,11.4,13.467Z",
    transform: "translate(-3.296 -4.552)",
    fill: "#3e4347"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_582",
    "data-name": "Ellipse 582",
    cx: 0.259,
    cy: 0.381,
    rx: 0.259,
    ry: 0.381,
    transform: "matrix(0.707, -0.707, 0.707, 0.707, 6.821, 8.334)",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10512",
    "data-name": "Path 10512",
    d: "M17.085,9.467c.271,4.646,1.464,4.189,3.275,4.189,1.669,0,2.916-1.876,2.781-4.189s-1.6-4.189-3.269-4.189S16.951,7.154,17.085,9.467Z",
    transform: "translate(-6.403 -1.979)",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10513",
    "data-name": "Path 10513",
    d: "M21.717,13.467a1.306,1.306,0,1,1-1.329-1.329A1.33,1.33,0,0,1,21.717,13.467Z",
    transform: "translate(-7.164 -4.552)",
    fill: "#3e4347"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_583",
    "data-name": "Ellipse 583",
    cx: 0.259,
    cy: 0.381,
    rx: 0.259,
    ry: 0.381,
    transform: "matrix(0.707, -0.707, 0.707, 0.707, 13.268, 8.334)",
    fill: "#fff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10514",
    "data-name": "Path 10514",
    d: "M19.313,21.141a1.388,1.388,0,0,1-1.137-.194,6.594,6.594,0,0,1-5.081,3.694,6.6,6.6,0,0,1-5.769-2.4,1.011,1.011,0,0,1-.562.375A.455.455,0,0,1,6.4,22.6,2.367,2.367,0,0,0,7.407,21.36c.081-.175.156-.3.156-.3a1.339,1.339,0,0,1-.187,1.119,8.751,8.751,0,0,0,5.619,1.531A8.613,8.613,0,0,0,18.119,20.9a1,1,0,0,1-.362-.562c-.056-.213,0-.369.012-.35C17.769,20.387,18.963,20.957,19.313,21.141Z",
    transform: "translate(-2.4 -7.496)",
    fill: "#3e4347"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVeryGoodGray);
export default __webpack_public_path__ + "static/media/very-good_gray.a04ceee0d1f2ec1af557ddd590b9dbd4.svg";
export { ForwardRef as ReactComponent };